// src/utils/encryption.js
import CryptoJS from 'crypto-js';

// Use environment variable for secret key, fallback for development
const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'MexyonSecureKey2024!@#$';

/**
 * Encrypt data before sending in URL
 * @param {Object} data - Data to encrypt
 * @returns {string} - Encrypted string
 */
export const encryptData = (data) => {
    try {
        const jsonString = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
        return encrypted;
    } catch (error) {
        console.error('Encryption error:', error);
        return null;
    }
};

/**
 * Decrypt data from URL parameter
 * @param {string} cipherText - Encrypted string
 * @returns {Object} - Decrypted data
 */
export const decryptData = (cipherText) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
        
        if (!decryptedString) {
            throw new Error('Decryption failed - invalid cipher text');
        }
        
        return JSON.parse(decryptedString);
    } catch (error) {
        console.error('Decryption error:', error);
        throw new Error('Failed to decrypt data. The link may be corrupted.');
    }
};